import {api} from "../../../system/api";
import {PREFIX_URL} from "../../../system/api/constants";

export default {
    getPriorities: project_id => api.get(PREFIX_URL.PROJECT + `/${project_id}/ticket-priorities`),
    updatePriority: (priorityId, params) => api.put(`/ticket-priorities/${priorityId}`, params),
    updatePosition: (project_id, params) => api.put(PREFIX_URL.PROJECT + `/${project_id}/ticket-priorities/positions`, params),
    createPriority: (projectId, params) => api.post(`/projects/${projectId}/ticket-priorities`, params),
}
